module.exports = __webpack_public_path__ + "static/img/manto-1.94613203.jpg";